/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Ai_Notice_TextInputs */

const en_candidate_ai_notice_text = /** @type {(inputs: Candidate_Ai_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema uses AI (Mistral) to analyze, match, and draft your application materials. All outputs are advisory suggestions you review before use.`)
};

const de_candidate_ai_notice_text = /** @type {(inputs: Candidate_Ai_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema verwendet KI (Mistral), um Ihre Bewerbungsunterlagen zu analysieren, abzugleichen und zu entwerfen. Alle Ausgaben sind beratende Vorschläge, die Sie vor der Verwendung prüfen.`)
};

const fr_candidate_ai_notice_text = /** @type {(inputs: Candidate_Ai_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema utilise l’IA (Mistral) pour analyser vos documents de candidature, les faire correspondre aux offres et les rédiger. Tous les résultats sont des suggestions consultatives que vous examinez avant utilisation.`)
};

const es_candidate_ai_notice_text = /** @type {(inputs: Candidate_Ai_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema utiliza IA (Mistral) para analizar, buscar coincidencias y redactar tus materiales de candidatura. Todos los resultados son sugerencias orientativas que revisas antes de usarlos.`)
};

const it_candidate_ai_notice_text = /** @type {(inputs: Candidate_Ai_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema utilizza l’IA (Mistral) per analizzare, abbinare e redigere i tuoi materiali di candidatura. Tutti i risultati sono suggerimenti consultivi che esamini prima dell’uso.`)
};

const nl_candidate_ai_notice_text = /** @type {(inputs: Candidate_Ai_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema gebruikt AI (Mistral) om je sollicitatiemateriaal te analyseren, te koppelen en op te stellen. Alle resultaten zijn adviserende suggesties die je vóór gebruik beoordeelt.`)
};

const pl_candidate_ai_notice_text = /** @type {(inputs: Candidate_Ai_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema używa AI (Mistral) do analizowania, dopasowywania i tworzenia materiałów aplikacyjnych. Wszystkie wyniki są sugestiami doradczymi, które przeglądasz przed użyciem.`)
};

const fi_candidate_ai_notice_text = /** @type {(inputs: Candidate_Ai_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema käyttää tekoälyä (Mistral) hakemusmateriaaliesi analysointiin, yhteensovittamiseen ja laatimiseen. Kaikki tulokset ovat neuvoa-antavia ehdotuksia, jotka tarkistat ennen käyttöä.`)
};

const da_candidate_ai_notice_text = /** @type {(inputs: Candidate_Ai_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema bruger AI (Mistral) til at analysere, matche og udarbejde dit ansøgningsmateriale. Alle resultater er vejledende forslag, som du gennemgår før brug.`)
};

const sv_candidate_ai_notice_text = /** @type {(inputs: Candidate_Ai_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema använder AI (Mistral) för att analysera, matcha och utforma ditt ansökningsmaterial. Alla resultat är vägledande förslag som du granskar före användning.`)
};

/**
* | output |
* | --- |
* | "Alchema uses AI (Mistral) to analyze, match, and draft your application materials. All outputs are advisory suggestions you review before use." |
*
* @param {Candidate_Ai_Notice_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const candidate_ai_notice_text = /** @type {((inputs?: Candidate_Ai_Notice_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Ai_Notice_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_ai_notice_text(inputs)
	if (locale === "fr") return fr_candidate_ai_notice_text(inputs)
	if (locale === "es") return es_candidate_ai_notice_text(inputs)
	if (locale === "it") return it_candidate_ai_notice_text(inputs)
	if (locale === "nl") return nl_candidate_ai_notice_text(inputs)
	if (locale === "pl") return pl_candidate_ai_notice_text(inputs)
	if (locale === "fi") return fi_candidate_ai_notice_text(inputs)
	if (locale === "da") return da_candidate_ai_notice_text(inputs)
	if (locale === "sv") return sv_candidate_ai_notice_text(inputs)
	return en_candidate_ai_notice_text(inputs)
});